import { React } from 'react';
import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import {
  TUTOR_COURSE_DELETE,
  TUTOR_COURSE_LIST_GET,
  TUTOR_EVENT_LIST_GET,
  UPDATE_COURSE_DETAILS_GET,
} from '../actions/tutorCourseList';
import tutorCourseList from '../../api/tutorCourseList';
import { ToastError } from '../../../ui/components/Toast';
import routes from '../../../routes';
import { formatPermissions } from '../../../utils/permissions';
import { PERMISSION_SET } from '../actions/permissions';
import coursedetails from '../../api/coursedetails';
import { errorHandling } from '../../../utils/errors';

function* tutorCourseListGet({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      tutorCourseList.tutorCourseListGet,
      {
        ...filters,
        typology: 'course',
      }
    );
    yield put({ type: TUTOR_COURSE_LIST_GET._SUCCESS, response, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > public > tutorCourseListGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* tutorCourseListGetWatch() {
  yield takeLatest(TUTOR_COURSE_LIST_GET._REQUEST, tutorCourseListGet);
}

function* updateCourseDetailsGet({ id, navigate }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: globalResponse } = {} } = yield call(
      coursedetails.getCourseDetails,
      { id }
    );
    const { data: { data: userResponse } = {} } = yield call(
      coursedetails.getCourseDetailsUser,
      { id }
    );
    yield put({
      type: UPDATE_COURSE_DETAILS_GET._SUCCESS,
      response: { ...globalResponse, ...userResponse },
    });
    // setPermissions
    const coursePermissions = formatPermissions(userResponse?.permissions);
    yield put({ type: PERMISSION_SET, data: coursePermissions, reset: true });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > public > updateCourseDetailsGet', err);
    toast.error(
      <ToastError
        title="Attenzione!"
        body="Non sei autorizzato a modificare il corso"
      />
    );
    navigate(routes.tutorCourseList.path);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* updateCourseDetailsGetWatch() {
  yield takeLatest(UPDATE_COURSE_DETAILS_GET._REQUEST, updateCourseDetailsGet);
}

function* tutorCourseDelete({ id, callback }) {
  try {
    yield put({ type: LOADER_OPEN });
    yield call(tutorCourseList.tutorCourseDelete, id);
    yield put({ type: TUTOR_COURSE_DELETE._SUCCESS });
    if (typeof callback === 'function') yield callback();
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > public > tutorCourseDelete', err);
    toast.error(
      <ToastError
        title="Attenzione!"
        body="Non sei autorizzato a eliminare il corso"
      />
    );
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* tutorCourseDeleteWatch() {
  yield takeLatest(TUTOR_COURSE_DELETE._REQUEST, tutorCourseDelete);
}

function* tutorEventListGet({ filters }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response, pager } = {} } = yield call(
      tutorCourseList.tutorCourseListGet,
      {
        ...filters,
        typology: 'event',
      }
    );
    yield put({ type: TUTOR_EVENT_LIST_GET._SUCCESS, response, pager });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > public > tutorEventListGet', err);
    errorHandling(err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* tutorEventListGetWatch() {
  yield takeLatest(TUTOR_EVENT_LIST_GET._REQUEST, tutorEventListGet);
}

export default [
  tutorCourseListGetWatch(),
  updateCourseDetailsGetWatch(),
  tutorCourseDeleteWatch(),
  tutorEventListGetWatch(),
];
